export function isKanbanBoardItemEqual(a, b) {
    return (a === b ||
        (a.id === b.id && a.taskId === b.taskId && a.columnId === b.columnId));
}
//# sourceMappingURL=isKanbanBoardItemEqual.js.map